module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0049.jpg?v=ff1bd62d";